import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useContacts } from '../contexts/ContactContext';
import ContactList from '../components/Contacts/ContactList';
import ContactModal from '../components/Contacts/ContactModal';
import ContactDetail from '../components/Contacts/ContactDetail';
import ImportModal from '../components/Contacts/ImportModal';
import ContactFilters from '../components/Contacts/ContactFilters';
import SafeIcon from '../common/SafeIcon';
import { FiMail, FiPhone, FiPlus, FiUpload } from 'react-icons/fi';


const Contacts = () => {
  const [showContactModal, setShowContactModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showContactDetail, setShowContactDetail] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [currentContactIndex, setCurrentContactIndex] = useState(0);

  const { selectedContacts, getFilteredContacts } = useContacts();
  const filteredContacts = getFilteredContacts();

  const handleEditContact = (contact) => {
    setSelectedContact(contact);
    setShowContactModal(true);
  };

  const handleViewContact = (contact) => {
    const contactIndex = filteredContacts.findIndex(c => c.id === contact.id);
    setSelectedContactId(contact.id);
    setCurrentContactIndex(contactIndex);
    setShowContactDetail(true);
  };

  const handleNavigateContact = async (contactId, newIndex) => {
    setSelectedContactId(contactId);
    setCurrentContactIndex(newIndex);
    // Add any additional navigation logic here (e.g., updating URL, analytics)
  };

  const handleCloseModal = () => {
    setShowContactModal(false);
    setSelectedContact(null);
  };

  const handleCloseDetail = () => {
    setShowContactDetail(false);
    setSelectedContactId(null);
    setCurrentContactIndex(0);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Contacts</h1>
          <p className="text-gray-600">
            Manage your recruitment prospects and relationships
          </p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={() => setShowImportModal(true)}
            className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <SafeIcon icon={FiUpload} className="text-sm" />
            Import
          </button>
          <button
            onClick={() => setShowContactModal(true)}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <SafeIcon icon={FiPlus} className="text-sm" />
            Add Contact
          </button>
        </div>
      </div>

      {/* Filters */}
      <ContactFilters />

      {/* Bulk Actions */}
      {selectedContacts.length > 0 && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-blue-50 border border-blue-200 rounded-lg p-4"
        >
          <div className="flex items-center justify-between">
            <span className="text-blue-800 font-medium">
              {selectedContacts.length} contact{selectedContacts.length > 1 ? 's' : ''} selected
            </span>
            <div className="flex gap-2">
              <button className="flex items-center gap-2 px-3 py-1 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm">
                <SafeIcon icon={FiPhone} className="text-xs" />
                Call Selected
              </button>
              <button className="flex items-center gap-2 px-3 py-1 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-sm">
                <SafeIcon icon={FiMail} className="text-xs" />
                Email Selected
              </button>
            </div>
          </div>
        </motion.div>
      )}

      {/* Contact List */}
      <ContactList
        contacts={filteredContacts}
        onEditContact={handleEditContact}
        onViewContact={handleViewContact}
      />

      {/* Modals */}
      {showContactModal && (
        <ContactModal contact={selectedContact} onClose={handleCloseModal} />
      )}

      {showImportModal && (
        <ImportModal onClose={() => setShowImportModal(false)} />
      )}

      {showContactDetail && (
        <ContactDetail
          contactId={selectedContactId}
          contactList={filteredContacts}
          currentIndex={currentContactIndex}
          onNavigate={handleNavigateContact}
          onClose={handleCloseDetail}
        />
      )}
    </div>
  );
};

export default Contacts;